/** The slice of a report query the load-state checks read. */
interface ReportQueryState {
  isError: boolean;
  data: unknown;
  isPlaceholderData: boolean;
}

/** A failed load takes over a reporting tab when there is nothing real to show:
 *  no data at all, or only the previous period's data held as a placeholder. */
export function isReportLoadFailed(query: ReportQueryState): boolean {
  return query.isError && (!query.data || query.isPlaceholderData);
}

/** A failed background refetch: the last good report stays on screen, with a notice. */
export function isReportRefreshFailed(query: ReportQueryState): boolean {
  return query.isError && Boolean(query.data) && !query.isPlaceholderData;
}

/** Dims a tab's content while a period switch still shows the previous period's data. */
export const REPORT_SWITCHING_CLASS = 'opacity-60 transition-opacity';
